import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  TextField,
  MenuItem,
  IconButton, FormControl,
  FormControlLabel,
  Switch,
  Modal,
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import CancelIcon from "@mui/icons-material/Cancel";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import CloseIcon from "@mui/icons-material/Close";

import { auth, db } from "../firebase";
import {
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
  doc,
  getDoc,
  addDoc,
  updateDoc,
  getDocs,
  Timestamp, runTransaction
} from "firebase/firestore";
import moment from "moment";
import Swal from "sweetalert2";
import { Autocomplete } from "@mui/material";
import Draggable from "react-draggable";
import CheckIcon from "@mui/icons-material/Check";
/* ================= TOAST ================= */
const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 2500,
});

const colors = {
  primary: "#1976d2",     // blue
  success: "#2e7d32",     // green
  danger: "#d32f2f",      // red
  warning: "#ed6c02",     // orange
  bg: "#f4f6f8",          // app background
  card: "#ffffff",
  soft: "#f9fafb",
};


/* ===================================================== */

export default function TableOrders() {
  /* ================= STATES ================= */
  const [userName, setuserName] = useState("");

  const [hotelname, setHotelname] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [address, setAddress] = useState("");
  const [city, setcity] = useState("");
  const [state, setstate] = useState("");
  const [pincode, setpincode] = useState("");
  const [gstname, setGstname] = useState("");
  const [gstno, setGstno] = useState("");
  const [roomposting, setroomposting] = useState('No');
  const [gstbill, setgstbill] = useState('No');

  const [propertyId, setPropertyId] = useState(null);
  const [runningOrders, setRunningOrders] = useState({});
  const [selectedProdCat, setSelectedProdCat] = useState(null);
  const [inputValue, setInputValue] = useState("");

  const [activeNoteId, setActiveNoteId] = useState(null);
  const [tempNote, setTempNote] = useState("");

  const [prodCats, setprodCats] = useState([]);
  const [seatCats, setSeatCats] = useState([]);
  const [seatings, setSeatings] = useState([]);
  const [products, setProducts] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [staffs, setstaffs] = useState([]);
  const [paymentModes, setPaymentModes] = useState([]);
  const [roomPostOpen, setRoomPostOpen] = useState(false);
  const [roomOptions, setRoomOptions] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState(null);

  const [customerId, setCustomerId] = useState("");
  const [waiterId, setWaiterId] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [noofpersons, setnoofpersons] = useState("");

  const [selectedTable, setSelectedTable] = useState(null);
  const [orderDuration, setOrderDuration] = useState("00:00:00");
  const [orderId, setOrderId] = useState(null);
  const [orderItems, setOrderItems] = useState([]);
  const [openProduct, setOpenProduct] = useState({
    name: "",
    qty: 1,
    rate: 0,
  });

  const [selectedProduct, setSelectedProduct] = useState(null);

  const [paymentOpen, setPaymentOpen] = useState(false);


  const [discountType, setDiscountType] = useState("amount"); // amount | percent
  const [discount, setDiscount] = useState(0);
  const [tip, setTip] = useState(0);
  const [paid, setPaid] = useState(0);
  const [payMode, setPayMode] = useState(" ");
  const [dragEnabled, setDragEnabled] = useState(false);

  const [cancelOpen, setCancelOpen] = useState(false);
  const [cancelItem, setCancelItem] = useState(null);
  const [cancelQty, setCancelQty] = useState(1);
  const [cancelNote, setCancelNote] = useState("");

  const [barcodeInput, setBarcodeInput] = useState("");

  const [kotPrinter, setKotPrinter] = useState("");
  const [billPrinter, setBillPrinter] = useState("");
  const [docId, setDocId] = useState(null);
  const [kotEnable, setKotEnable] = useState(false);
  const [finalPrint, setfinalPrint] = useState(true);
  const [openTableModal, setOpenTableModal] = useState(false);

  useEffect(() => {
    const handleKeyDown = async (e) => {
      if (!selectedTable) return;

      switch (e.key) {
        case "F1":
          e.preventDefault();
          await printKOT();
          break;

        case "F2":
          e.preventDefault();
          await printBill();
          break;

        case "F3":
          e.preventDefault();
          setPaymentOpen(true);
          break;

        case "F4":
          e.preventDefault();
          setRoomPostOpen(true);
          break;

        // case "F8":
        //   e.preventDefault();
        //   await cancelOrder();
        //   break;

        default:
          break;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedTable, orderId, orderItems]);

  useEffect(() => {
    if (!orderId) {
      setOrderItems([]);
      return;
    }

    const unsub = onSnapshot(
      query(
        collection(db, "orderitems"),
        where("orderid", "==", orderId),
        orderBy("createdAt", "desc")
      ),
      (snap) => {
        setOrderItems(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      }
    );

    return () => unsub();
  }, [orderId]);

  useEffect(() => {
    const loadSettings = async () => {
      if (!propertyId) return;

      const q = query(
        collection(db, "printerSettings"),
        where("propertyId", "==", propertyId)
      );

      const snap = await getDocs(q);

      if (!snap.empty) {
        const data = snap.docs[0].data();
        console.log(data);

        setDocId(snap.docs[0].id);
        setKotPrinter(data.kotPrinter || "");
        setBillPrinter(data.billPrinter || "");
      }
    };

    loadSettings();
  }, [propertyId]);

  useEffect(() => {
    if (!orderId) {
      setOrderDuration("00:00:00");
      return;
    }

    const interval = setInterval(async () => {
      const snap = await getDoc(doc(db, "orders", orderId));
      if (!snap.exists()) return;

      const data = snap.data();
      const start = data.createdAt?.toDate();
      if (!start) return;

      const now = new Date();
      const diff = Math.floor((now - start) / 1000); // seconds

      const hours = String(Math.floor(diff / 3600)).padStart(2, "0");
      const minutes = String(Math.floor((diff % 3600) / 60)).padStart(2, "0");
      const seconds = String(diff % 60).padStart(2, "0");

      setOrderDuration(`${hours}:${minutes}:${seconds}`);
    }, 1000);

    return () => clearInterval(interval);
  }, [orderId]);

  /* ================= AUTH ================= */
  useEffect(() => {
    const unsub = auth.onAuthStateChanged(async (u) => {
      if (!u) return;

      const roleSnap = await getDoc(doc(db, "authroles", u.uid));
      if (!roleSnap.exists()) {
        Toast.fire({ icon: "error", title: "Property not assigned" });
        return;
      }
      setPropertyId(roleSnap.data().propertyId);
      setuserName(roleSnap.data().name)
    });
    return () => unsub();
  }, []);



  useEffect(() => {
    if (!propertyId) return;

    return onSnapshot(
      query(collection(db, "restocustomers"), where("propertyId", "==", propertyId)),
      (snap) =>
        setCustomers(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
    );
  }, [propertyId]);

  useEffect(() => {
    if (!propertyId) return;

    return onSnapshot(
      query(collection(db, "staffs"), where("propertyId", "==", propertyId)),
      (snap) =>
        setstaffs(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
    );
  }, [propertyId]);





  useEffect(() => {
    if (!orderId) return;

    updateDoc(doc(db, "orders", orderId), {
      customerid: customerId || "",
      waiterid: waiterId || "",
      noofpersons: noofpersons || "",
      updatedAt: Timestamp.now(),
      userid: auth.currentUser?.uid,

    });
  }, [customerId, waiterId, orderId, noofpersons]);


  useEffect(() => {
    if (!propertyId) return; // Ensure propertyId is set

    const fetchRestoDetails = async () => {
      try {
        // 2️⃣ Query restodetails collection where propertyId matches
        const restodetailsQuery = query(
          collection(db, "properties"),
          where("propertyId", "==", propertyId)
        );

        const querySnap = await getDocs(restodetailsQuery);

        // 3️⃣ Map the results
        const allRestoDetails = querySnap.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        // 4️⃣ Store first resto details in state
        if (allRestoDetails.length > 0) {
          const firstResto = allRestoDetails[0];
          setHotelname(firstResto.hotelname || "");
          setEmail(firstResto.email || "");
          setMobile(firstResto.mobile || "");
          setAddress(firstResto.address || "");
          setcity(firstResto.city || "");
          setstate(firstResto.state || "");
          setpincode(firstResto.pincode || "");
          setGstname(firstResto.gstname || "");
          setGstno(firstResto.gstno || "");
          setroomposting(firstResto.roomposting || "");
          setgstbill(firstResto.gstbill || "");
        }
        // Optionally, store the full list if needed
        // setAllRestos(allRestoDetails);

      } catch (err) {
        console.log({ icon: "error", title: err.message });
      }
    };

    fetchRestoDetails();
  }, [propertyId]); // run when propertyId changes


  useEffect(() => {
    if (!propertyId) return;

    return onSnapshot(
      query(
        collection(db, "restopaymodes"),
        where("propertyId", "==", propertyId)
      ),
      (snap) =>
        setPaymentModes(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
    );
  }, [propertyId]);

  useEffect(() => {
    if (!propertyId) return;

    return onSnapshot(
      query(
        collection(db, "reservations"),
        where("propertyId", "==", propertyId),
        where("status", "==", "Booked")
      ),
      (snap) => {
        const allRooms = [];

        snap.docs.forEach(docSnap => {
          const data = docSnap.data();

          const customer = data.customers || {};
          const rooms = data.rooms || [];

          rooms.forEach((room) => {
            allRooms.push({
              reservationId: docSnap.id,
              roomid: room.roomid,
              roomno: room.roomno,
              roomtype: room.roomtypename,
              roomrate: room.roomrate,
              custname: customer.custname,
              mobile: customer.mobile,
              email: customer.email,
              _raw: data,
            });
          });
        });

        setRoomOptions(allRooms);
      }
    );
  }, [propertyId, roomPostOpen]);


  /* ================= SEATING CATEGORIES ================= */
  useEffect(() => {
    if (!propertyId) return;

    return onSnapshot(
      query(collection(db, "seatingcats"), where("propertyId", "==", propertyId), orderBy('priority', 'asc')),
      (snap) =>
        setSeatCats(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
    );
  }, [propertyId]);

  useEffect(() => {
    if (!propertyId) return;

    return onSnapshot(
      query(collection(db, "productcats"), where("propertyId", "==", propertyId), orderBy('priority', 'asc')),
      (snap) =>
        setprodCats(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
    );
  }, [propertyId]);

  /* ================= TABLES ================= */
  useEffect(() => {
    if (!propertyId) return;

    return onSnapshot(
      query(collection(db, "seatings"), where("propertyId", "==", propertyId)), orderBy('seatname', 'asc'),
      (snap) =>
        setSeatings(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
    );
  }, [propertyId]);

  /* ================= PRODUCTS ================= */
  useEffect(() => {
    if (!propertyId) return;

    return onSnapshot(
      query(
        collection(db, "products"),
        where("propertyId", "==", propertyId),
        orderBy("prodname", "asc")
      ),

      (snap) => {
        const sorted = snap.docs
          .map((d) => ({ id: d.id, ...d.data() }))
          .sort((a, b) => {
            if (a.priority === 0 && b.priority !== 0) return 1;
            if (a.priority !== 0 && b.priority === 0) return -1;
            return (a.priority || 0) - (b.priority || 0);
          });

        setProducts(sorted);
      }

    );
  }, [propertyId]);

  useEffect(() => {
    if (!propertyId) return;

    const ordersRef = query(
      collection(db, "orders"),
      where("propertyId", "==", propertyId),
      where("status", "==", "RUNNING")
    );

    const itemsRef = query(
      collection(db, "orderitems"),
      where("propertyId", "==", propertyId)
    );

    let ordersData = [];
    let itemsData = [];

    const unsubscribeOrders = onSnapshot(ordersRef, (orderSnap) => {
      ordersData = orderSnap.docs.map(d => ({
        id: d.id,
        ...d.data()
      }));

      buildRunningMap();
    });

    const unsubscribeItems = onSnapshot(itemsRef, (itemSnap) => {
      itemsData = itemSnap.docs.map(d => ({
        id: d.id,
        ...d.data()
      }));

      buildRunningMap();
    });

    const buildRunningMap = () => {
      const runningMap = {};

      ordersData.forEach(order => {
        const items = itemsData.filter(
          item => item.orderid === order.id
        );

        const liveTotal = items.reduce(
          (sum, i) => sum + (i.qty || 0) * (i.rate || 0),
          0
        );

        runningMap[String(order.tableid)] = {
          ...order,
          id: order.id,
          liveTotal,
        };
      });

      setRunningOrders(runningMap);
    };

    return () => {
      unsubscribeOrders();
      unsubscribeItems();
    };

  }, [propertyId]);
  /* ================= GROUP TABLES ================= */
  const groupedTables = seatCats.map((cat) => ({
    ...cat,
    tables: seatings
      .filter((table) => table.seatcatid === cat.id)
      .sort((a, b) => {
        const aTime = a.createdAt?.seconds || 0;
        const bTime = b.createdAt?.seconds || 0;
        return aTime - bTime; // ASC
      }),
  }));


  /* ================= OPEN TABLE ================= */
  const openTable = async (table) => {
    setSelectedTable(table);
    setCustomerId("");
    setPaymentMode("");
    setWaiterId("");          // 🔥 THIS LINE WAS MISSING
    setDiscount(0);
    setTip(0);
    setPaid(0);
    setKotEnable(false)
    const runningOrder = runningOrders[String(table.id)];

    if (runningOrder) {
      setOrderId(runningOrder.id);
      setCustomerId(runningOrder.customerid || "");
      setPaymentMode(runningOrder.paymentmode || "");
      setWaiterId(runningOrder.waiterid || "");
      setnoofpersons(runningOrder.noofpersons || "");

      // 🔥 LIVE ITEMS LISTENER
      // onSnapshot(
      //   query(
      //     collection(db, "orderitems"),
      //     where("orderid", "==", runningOrder.id),
      //     orderBy("createdAt", "asc")
      //   ),
      //   (snap) => {
      //     setOrderItems(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      //   }
      // );

    } else {
      // const ref = await addDoc(collection(db, "orders"), {
      //   propertyId,
      //   tableid: table.id,
      //   status: "RUNNING",
      //   customerid: "",
      //   paymentmode: "",
      //   createdAt: Timestamp.now(),
      // });

      setOrderId(null);
      setOrderItems([]);
    }
  };


  const addItem = async (product) => {
    let currentOrderId = orderId;

    if (!currentOrderId) {

      const ref = await addDoc(collection(db, "orders"), {
        propertyId,
        tableid: selectedTable.id,
        status: "RUNNING",
        customerid: customerId || "",
        waiterid: waiterId || "",
        noofpersons: noofpersons || "",
        paymentmode: paymentMode || "",
        createdAt: Timestamp.now(),
        reservationId: '',
        userid: auth.currentUser?.uid,
        billPrinted: false,
      });

      currentOrderId = ref.id;
      setOrderId(ref.id);

    } else {
      console.log("Order already exists — billno will not regenerate");
    }

    // 🔍 check if product already exists
    const q = query(
      collection(db, "orderitems"),
      where("orderid", "==", currentOrderId),
      where("productid", "==", product.id)
    );

    const snap = await getDocs(q);

    if (!snap.empty) {
      // ✅ increase qty
      const docRef = doc(db, "orderitems", snap.docs[0].id);
      const oldQty = snap.docs[0].data().qty;

      await updateDoc(docRef, {
        qty: oldQty + 1,
      });

      await addUserLog({
        action: "UPDATE",
        module: "ORDER_ITEM",
        description: `Increased qty of ${product.prodname}`,
        orderid: currentOrderId,
        itemid: snap.docs[0].id
      });
    } else {
      // ➕ add new item
      await addDoc(collection(db, "orderitems"), {
        orderid: currentOrderId,
        productid: product.id,
        name: product.prodname,
        rate: product.rate,
        qty: 1,
        kot: false,
        printedQty: 0,   // IMPORTANT
        note: "", // 👈 ADD THIS
        propertyId,
        createdAt: Timestamp.now(),
        userid: auth.currentUser?.uid

      });

      await addUserLog({
        action: "ADD",
        module: "ORDER_ITEM",
        description: `Added ${product.prodname} to order`,
        orderid: currentOrderId
      });
    }
  };

  const increaseQty = async (item) => {
    await updateDoc(doc(db, "orderitems", item.id), {
      qty: item.qty + 1,
    });

    await addUserLog({
      action: "UPDATE",
      module: "ORDER_ITEM",
      description: `Increased qty of ${item.name}`,
      orderid: orderId,
      itemid: item.id
    });
  };

  const decreaseQty = async (item) => {
    const printed = item.printedQty || 0;

    // ❌ Cannot reduce below printed qty
    if (item.qty - 1 < printed) {
      // Swal.fire(
      //   "Not Allowed",
      //   "Use Cancel KOT to reduce printed quantity",
      //   "warning"
      // );
      return;
    }

    if (item.qty <= 1) {
      await updateDoc(doc(db, "orderitems", item.id), {
        qty: 0,
      });
    } else {
      await updateDoc(doc(db, "orderitems", item.id), {
        qty: item.qty - 1,
      });
    }

    await addUserLog({
      action: "UPDATE",
      module: "ORDER_ITEM",
      description: `Decreased qty of ${item.name}`,
      orderid: orderId,
      itemid: item.id
    });
  };

  const updateNote = async (item, newNote) => {
    await updateDoc(doc(db, "orderitems", item.id), {
      note: newNote,
    });

    await addUserLog({
      action: "UPDATE",
      module: "ORDER_ITEM",
      description: `Updated note for ${item.name}`,
      orderid: orderId,
      itemid: item.id
    });
  };


  // Base total (items total)
  const totalAmount = orderItems.reduce(
    (sum, i) => sum + i.qty * i.rate,
    0
  );

  // ================= DISCOUNT =================
  let discountAmount = 0;

  if (discountType === "percent") {
    discountAmount = (totalAmount * Number(discount || 0)) / 100;
  } else {
    discountAmount = Number(discount || 0);
  }

  if (discountAmount > totalAmount) {
    discountAmount = totalAmount;
  }

  // ================= FINAL TOTAL =================
  const finalTotal =
    totalAmount - discountAmount + Number(tip || 0);

  // ================= REMAINING =================
  const remaining = finalTotal - Number(paid || 0);



  const printKOT = async () => {
    if (!orderId) return;

    const kotItems = orderItems.filter(
      item => item.qty > (item.printedQty || 0)
    );

    if (!kotItems.length) {
      Toast.fire({ icon: "info", title: "No new items for KOT" });
      return;
    }

    // ✅ Get customer details
    const selectedCustomer = customers.find(c => c.id === customerId);
    const customerName = selectedCustomer ? selectedCustomer.name : "Walk-in";
    const waiterName = waiterId || "";

    // ✅ Build Items HTML
    let itemsHTML = "";

    for (let item of kotItems) {
      const balanceQty = item.qty - (item.printedQty || 0);

      itemsHTML += `
        <div style="
            margin-bottom:8px; 
            padding:6px; 
            border:1px dashed #000; 
            border-radius:6px;
        ">
          
          <div style="
              display:flex; 
              justify-content:space-between; 
              align-items:center;
          ">
            
            <div style="
                font-weight:bold; 
                font-size:13px; 
                max-width:130px; 
                word-wrap:break-word;
            ">
              ${item.name}
            </div>

            <div style="
                font-weight:bold;
                font-size:16px;
                border:1px solid #000;
                padding:2px 8px;
                border-radius:4px;
                min-width:28px;
                text-align:center;
            ">
              ${balanceQty}
            </div>

          </div>

          ${item.note ? `
            <div style="
                margin-top:4px;
                font-size:10px;
                font-style:italic;
                border-top:1px dotted #000;
                padding-top:3px;
            ">
              📝 ${item.note}
            </div>
          ` : ""}

        </div>
      `;

      const newBatch = {
        qty: balanceQty,
        cancelledQty: 0,
        printedAt: Timestamp.now(),
      };

      await updateDoc(doc(db, "orderitems", item.id), {
        printedQty: item.qty,
        kotPrintHistory: [...(item.kotPrintHistory || []), newBatch],
      });
    }

    // ✅ Final KOT HTML
    const htmlContent = `
  <html>
  <body style="font-family: monospace; font-size:12px; width:260px; margin:0;">

    <div style="text-align:center; font-size:16px; font-weight:bold;">
      KITCHEN ORDER TICKET
    </div>

    <div style="border-top:1px dashed #000; margin:6px 0;"></div>

    <div><b>Table:</b> ${selectedTable?.seatname || ""}</div>
    <div><b>Date:</b> ${moment().format("DD-MM-YYYY HH:mm")}</div>

    <div style="border-top:1px dashed #000; margin:6px 0;"></div>

    ${itemsHTML}

    <div style="border-top:1px dashed #000; margin:6px 0;"></div>

    <div style="text-align:center; font-size:10px;">
      --- END OF KOT ---
    </div>

  </body>
  </html>
  `;



    // ✅ Send to Electron Silent Print
    await window.electronAPI.silentPrint(htmlContent, kotPrinter);


    await addUserLog({
      action: "PRINT",
      module: "KOT",
      description: `KOT Printed for Table ${selectedTable?.seatname}`,
      orderid: orderId
    });
    setKotEnable(true); // mark as printed

    Toast.fire({ icon: "success", title: "KOT Printed" });
  };


  const cancelOrder = async () => {
    await updateDoc(doc(db, "orders", orderId), {
      status: "CANCELLED",
      cancelledAt: Timestamp.now(),
    });

    await addUserLog({
      action: "CANCEL",
      module: "ORDER",
      description: `Order cancelled for Table ${selectedTable?.seatname}`,
      orderid: orderId
    });

    Toast.fire({ icon: "info", title: "Order Cancelled" });
    closePopup();
  };

  const handleCategoryClick = (catId) => {
    setSelectedProdCat(catId);
  };

  const filteredProducts = selectedProdCat
    ? products.filter(p =>
      String(p.catid?.id || p.catid || p.prodcatid) === String(selectedProdCat)
    )
    : products;


  const addOpenProduct = async () => {
    if (!openProduct.name || !openProduct.rate || !selectedTable) return;

    let currentOrderId = orderId;

    // 🔥 AUTO CREATE ORDER IF NOT EXISTS
    if (!currentOrderId) {
      const ref = await addDoc(collection(db, "orders"), {
        propertyId,
        tableid: selectedTable.id,
        status: "RUNNING",
        waiterid: waiterId || "",
        noofpersons: noofpersons || "",
        customerid: customerId || "",
        paymentmode: paymentMode || "",
        createdAt: Timestamp.now(),
        reservationId: "",
        userid: auth.currentUser?.uid

      });

      currentOrderId = ref.id;
      setOrderId(ref.id);
    }

    // ➕ ADD OPEN PRODUCT
    await addDoc(collection(db, "orderitems"), {
      propertyId,
      orderid: currentOrderId,
      productid: null,        // 🔑 open item
      name: openProduct.name,
      qty: Number(openProduct.qty || 1),
      rate: Number(openProduct.rate),
      isOpen: true,
      kot: false,
      note: "", // 👈 ADD THIS
      createdAt: Timestamp.now(),
      userid: auth.currentUser?.uid

    });

    await addUserLog({
      action: "ADD",
      module: "OPEN PRODUCTS",
      description: `Open Product Added ${openProduct.name}`,
      orderid: '',
      itemid: ''
    });

    // 🔄 RESET INPUT
    setOpenProduct({ name: "", qty: 1, rate: 0 });
  };


  const closePopup = () => {
    setSelectedTable(null);
    setOrderItems([]);
    setOrderId(null);
  };


  const printBill = async () => {

    let customerData = null;

    if (customerId) {
      const custSnap = await getDoc(doc(db, "restocustomers", customerId));
      if (custSnap.exists()) {
        customerData = custSnap.data();
      }
    }

    let subTotal = totalAmount;
    let cgst = 0;
    let sgst = 0;
    let finalTotal = 0;

    if (gstbill === "Yes") {
      // Reverse calculate subtotal (remove 5% GST)
      subTotal = totalAmount / 1.05;

      const gstAmount = totalAmount - subTotal;

      cgst = gstAmount / 2;
      sgst = gstAmount / 2;
    }

    // ================= DISCOUNT =================

    let discountAmount = 0;

    if (discountType === "percent") {
      discountAmount = (subTotal * Number(discount || 0)) / 100;
    } else {
      discountAmount = Number(discount || 0);
    }

    if (discountAmount > subTotal) {
      discountAmount = subTotal;
    }

    // Apply discount on subtotal
    let afterDiscount = subTotal - discountAmount;

    // If GST enabled, re-apply GST after discount
    if (gstbill === "Yes") {
      cgst = afterDiscount * 0.025;
      sgst = afterDiscount * 0.025;
      finalTotal = afterDiscount + cgst + sgst + Number(tip || 0);
    } else {
      finalTotal = afterDiscount + Number(tip || 0);
    }


    const htmlContent = `
<html>
<body style="font-family: monospace; font-size:12px; width:260px; margin:0; ">
  <!-- ===== HEADER ===== -->
  <div style="border-top:2px solid #000; margin:8px 0;"></div>

  <div style="text-align:center;">
    <div style="font-size:18px; font-weight:bold; letter-spacing:1px;">
      ${hotelname || "Restaurant Name"}
    </div>

    <div style="font-size:11px; margin-top:2px;">
      ${address || ""}  ${city || ""}   ${state || ""}   ${pincode || ""} 
    </div>

    <div style="font-size:11px;">
      Mob: ${mobile || ""}
    </div>

    ${email ? `<div style="font-size:11px;">${email}</div>` : ""}

    ${gstbill === "Yes" ? `
      <div style="font-size:11px; margin-top:2px;">
        GSTIN: ${gstno || ""}
      </div>
    ` : ""}
  </div>

  <div style="border-top:2px solid #000; margin:8px 0;"></div>

    <div style="font-size:11px;">

      <table style="width:100%; font-size:11px;">
        <tr>
          <td style="text-align:left;">
            <b>Date:</b> ${moment().format("DD-MM-YYYY HH:mm")}
          </td>
          <td style="text-align:right;">
            <b>Table:</b> ${selectedTable?.seatname || ""}
          </td>
        </tr>

        <tr>
          <td style="text-align:left;">
            <b>Printed By:</b> ${userName}
          </td>
          <td style="text-align:right;">
            <b>Waiter:</b> ${waiterId}
          </td>
        </tr>
      </table>

      ${customerData ? `
        <table style="width:100%; font-size:11px; ">
          <tr>
            <td style="text-align:left;">
              <b>Customer:</b> ${customerData.name || ""}
            </td>
            <td style="text-align:left;">
              <b>Mobile:</b> ${customerData.mobile || ""}
            </td>
          </tr>
        </table>
      ` : ""}

    </div>


  <div style="border-top:1px dashed #000; margin:8px 0;"></div>

  <!-- ===== ITEMS TABLE ===== -->
  <table style="width:100%; font-size:12px;">
    <tr style="border-bottom:1px solid #000;">
      <th style="text-align:left;">Item</th>
      <th style="text-align:center;">Rate</th>
      <th style="text-align:center;">Qty</th>
      <th style="text-align:right;">Amt</th>
    </tr>

    ${orderItems
        .filter(i => Number(i.qty) > 0)   // ✅ remove zero qty
        .map(i => `
    <tr>
      <td style="padding-top:4px; max-width:110px; word-wrap:break-word;">
        ${i.name}
      </td>
      <td style="text-align:center;">
        ${i.rate}
      </td>
      <td style="text-align:center;">
        ${i.qty}
      </td>
      <td style="text-align:right;font-weight:bold;">
        ${(i.qty * i.rate).toFixed(2)}
      </td>
    </tr>
  `).join("")}
  </table>

  <div style="border-top:1px dashed #000; margin:8px 0;"></div>

  <!-- ===== TOTAL SECTION ===== -->
  <div style="font-size:12px;">

    <div style="display:flex; justify-content:space-between;">
      <span>Sub Total</span>
      <span>₹ ${subTotal.toFixed(2)}</span>
    </div>

    ${gstbill === "Yes" ? `
      <div style="display:flex; justify-content:space-between;">
        <span>CGST 2.5%</span>
        <span>₹ ${cgst.toFixed(2)}</span>
      </div>

      <div style="display:flex; justify-content:space-between;">
        <span>SGST 2.5%</span>
        <span>₹ ${sgst.toFixed(2)}</span>
      </div>
    ` : ""}

  </div>

  <div style="border-top:2px solid #000; margin:8px 0;"></div>

  <!-- ===== GRAND TOTAL ===== -->
  <div style="
      display:flex; 
      justify-content:space-between; 
      font-size:15px; 
      font-weight:bold;
  ">
    <span>GRAND TOTAL</span>
    <span>₹ ${finalTotal.toFixed(2)}</span>
  </div>

  <div style="border-top:2px solid #000; margin:8px 0;"></div>

  <!-- ===== FOOTER ===== -->
  <div style="text-align:center; font-size:10px; margin-top:6px;">
    Thank You! Visit Again 🙏 <br/>
    <span style="font-size:9px;">
      Software by <b>Reszio</b>
    </span>
  </div>

</body>
</html>
`;


    await window.electronAPI.silentPrint(htmlContent, billPrinter);

    await addUserLog({
      action: "BILL",
      module: "PRINT",
      description: `${selectedTable?.seatname}`,
      orderid: orderId,
      itemid: ''
    });


    const orderSnap = await getDoc(doc(db, "orders", orderId));
    const orderData = orderSnap.data();

    if (orderData.billPrinted) {
      Toast.fire({ icon: "info", title: "Bill already printed" });
      return;
    }

    await updateDoc(doc(db, "orders", orderId), {
      billPrinted: true,
    });

  };

  const FinalBill = async () => {

    let subTotal = totalAmount;
    let cgst = 0;
    let sgst = 0;
    let finalTotal = 0;

    if (gstbill === "Yes") {
      // Reverse calculate subtotal (remove 5% GST)
      subTotal = totalAmount / 1.05;

      const gstAmount = totalAmount - subTotal;

      cgst = gstAmount / 2;
      sgst = gstAmount / 2;
    }

    // ================= DISCOUNT =================

    let discountAmount = 0;

    if (discountType === "percent") {
      discountAmount = (subTotal * Number(discount || 0)) / 100;
    } else {
      discountAmount = Number(discount || 0);
    }

    if (discountAmount > subTotal) {
      discountAmount = subTotal;
    }

    // Apply discount on subtotal
    let afterDiscount = subTotal - discountAmount;

    // If GST enabled, re-apply GST after discount
    if (gstbill === "Yes") {
      cgst = afterDiscount * 0.025;
      sgst = afterDiscount * 0.025;
      finalTotal = afterDiscount + cgst + sgst + Number(tip || 0);
    } else {
      finalTotal = afterDiscount + Number(tip || 0);
    }


    const htmlContent = `
<html>
<body style="font-family: monospace; font-size:12px; width:260px; margin:0; ">
  <!-- ===== HEADER ===== -->
  <div style="border-top:2px solid #000; margin:8px 0;"></div>

  <div style="text-align:center;">
    <div style="font-size:18px; font-weight:bold; letter-spacing:1px;">
      ${hotelname || "Restaurant Name"}
    </div>

    <div style="font-size:11px; margin-top:2px;">
      ${address || ""}  ${city || ""}   ${state || ""}   ${pincode || ""} 
    </div>

    <div style="font-size:11px;">
      Mob: ${mobile || ""}
    </div>

    ${email ? `<div style="font-size:11px;">${email}</div>` : ""}

    ${gstbill === "Yes" ? `
      <div style="font-size:11px; margin-top:2px;">
        GSTIN: ${gstno || ""}
      </div>
    ` : ""}
  </div>

  <div style="border-top:2px solid #000; margin:8px 0;"></div>

  <!-- ===== BILL INFO ===== -->
  <div style="font-size:11px;">
    <div style="display:flex; justify-content:space-between;">
      <span><b>Table:</b> ${selectedTable?.seatname || ""}</span><br/>
     <div><b>Bill No:</b> ${runningOrders[String(selectedTable?.id)]?.billno || ""}</div>
    </div>
     <span><b>Date:</b></span> ${moment().format("DD-MM-YYYY HH:mm")} <br/>

    <div style="margin-top:4px;">
      <b>Printed By:</b> ${userName}
    </div>
  </div>

  <div style="border-top:1px dashed #000; margin:8px 0;"></div>

  <!-- ===== ITEMS TABLE ===== -->
  <table style="width:100%; font-size:12px;">
    <tr style="border-bottom:1px solid #000;">
      <th style="text-align:left;">Item</th>
      <th style="text-align:center;">Rate</th>
      <th style="text-align:center;">Qty</th>
      <th style="text-align:right;">Amt</th>
    </tr>

    ${orderItems
        .filter(i => Number(i.qty) > 0)   // ✅ remove zero qty
        .map(i => `
    <tr>
      <td style="padding-top:4px; max-width:110px; word-wrap:break-word;">
        ${i.name}
      </td>
      <td style="text-align:center;">
        ${i.rate}
      </td>
      <td style="text-align:center;">
        ${i.qty}
      </td>
      <td style="text-align:right;font-weight:bold;">
        ${(i.qty * i.rate).toFixed(2)}
      </td>
    </tr>
  `).join("")}
  </table>

  <div style="border-top:1px dashed #000; margin:8px 0;"></div>

  <!-- ===== TOTAL SECTION ===== -->
  <div style="font-size:12px;">

    <div style="display:flex; justify-content:space-between;">
      <span>Sub Total</span>
      <span>₹ ${subTotal.toFixed(2)}</span>
    </div>

    ${gstbill === "Yes" ? `
      <div style="display:flex; justify-content:space-between;">
        <span>CGST 2.5%</span>
        <span>₹ ${cgst.toFixed(2)}</span>
      </div>

      <div style="display:flex; justify-content:space-between;">
        <span>SGST 2.5%</span>
        <span>₹ ${sgst.toFixed(2)}</span>
      </div>
    ` : ""}

  </div>

  <div style="border-top:2px solid #000; margin:8px 0;"></div>

  <!-- ===== GRAND TOTAL ===== -->
  <div style="
      display:flex; 
      justify-content:space-between; 
      font-size:15px; 
      font-weight:bold;
  ">
    <span>GRAND TOTAL</span>
    <span>₹ ${finalTotal.toFixed(2)}</span>
  </div>

  <div style="border-top:2px solid #000; margin:8px 0;"></div>

  <!-- ===== FOOTER ===== -->
  <div style="text-align:center; font-size:10px; margin-top:6px;">
    Thank You! Visit Again 🙏 <br/>
    <span style="font-size:9px;">
      Software by <b>Reszio</b>
    </span>
  </div>

</body>
</html>
`;


    await window.electronAPI.silentPrint(htmlContent, billPrinter);

    await addUserLog({
      action: "BILL",
      module: "PRINT",
      description: `${selectedTable?.seatname}`,
      orderid: orderId,
      itemid: ''
    });


    const orderSnap = await getDoc(doc(db, "orders", orderId));
    const orderData = orderSnap.data();

    if (orderData.billPrinted) {
      Toast.fire({ icon: "info", title: "Bill already printed" });
      return;
    }

    await updateDoc(doc(db, "orders", orderId), {
      billPrinted: true,
    });

  };

  const billAlreadyPrinted = runningOrders[String(selectedTable?.id)]?.billPrinted;

  const generateBillNumbers = async () => {
    if (!propertyId) throw new Error("PropertyId missing");

    const today = moment().format("YYYY-MM-DD");

    // 🔑 PROPERTY-WISE COUNTER DOC
    const counterRef = doc(db, "counters", `bills_${propertyId}`);

    const result = await runTransaction(db, async (transaction) => {
      const snap = await transaction.get(counterRef);

      let overall = 1;
      let daily = 1;

      if (snap.exists()) {
        const data = snap.data();

        overall = (data.overallBillNo || 0) + 1;
        daily = (data.daily?.[today] || 0) + 1;

        transaction.update(counterRef, {
          overallBillNo: overall,
          [`daily.${today}`]: daily,
          updatedAt: Timestamp.now(),
        });
      } else {
        transaction.set(counterRef, {
          propertyId,
          overallBillNo: 1,
          daily: {
            [today]: 1,
          },
          createdAt: Timestamp.now(),
        });
      }

      return { overall, daily };
    });

    return result;
  };

  const finalSaveBill = async () => {
    if (paid > finalTotal) {
      alert("Paid amount cannot be greater than total");
      return;
    }
    if (!orderId) return;

    const { overall, daily } = await generateBillNumbers();

    // 🔥 2️⃣ Save bill into orders
    await updateDoc(doc(db, "orders", orderId), {
      status: "BILLED",
      billno: overall,
      daybillno: daily,         // ✅ daily bill number
      billdate: Timestamp.now(),
      totalamount: totalAmount,
      discountType,
      discountValue: discount,
      discountAmount,
      tip: Number(tip || 0),
      finalTotal,
      paid: Number(paid || 0),
      remaining,
      waiterid: waiterId || "",
      noofpersons: noofpersons || "",
      customerid: customerId || "",
      paymentmode: payMode || "",
      userid: auth.currentUser?.uid,

      updatedAt: Timestamp.now(),
    });

    // 🔥 3️⃣ Free the table
    await updateDoc(doc(db, "seatings", selectedTable.id), {
      status: "FREE",
      color: "green",
    });

    await addUserLog({
      action: "BILL_SAVE",
      module: "BILL",
      description: `Bill #${overall} generated for Table ${selectedTable?.seatname}`,
      orderid: orderId
    });

    if (finalPrint) {
      FinalBill();
    }

    setfinalPrint(false)

    Swal.fire("Success", "Bill saved successfully", "success");

    setPaymentOpen(false);
    closePopup();
  };



  const postToRoom = async () => {
    if (!selectedRoom || !orderId) return;

    // 1️⃣ Generate bill numbers
    const { overall, daily } = await generateBillNumbers();

    // 2️⃣ Save bill in orders (ALL REQUIRED FIELDS)
    await updateDoc(doc(db, "orders", orderId), {
      status: "BILLED",
      daybillno: daily,
      billdate: Timestamp.now(),
      orderType: "ROOM",          // 🔥 IMPORTANT

      totalamount: totalAmount,
      discount: Number(discount || 0),
      tip: Number(tip || 0),
      paid: 0,
      remaining: finalTotal,

      waiterid: waiterId || "",
      noofpersons: noofpersons || "",
      customerid: customerId || "",
      paymentmode: "",
      reservationId: selectedRoom.reservationId,
      updatedAt: Timestamp.now(),
      userid: auth.currentUser?.uid,

    });

    await addDoc(collection(db, "roompostings"), {
      propertyId,

      reservationId: selectedRoom.reservationId,
      roomid: selectedRoom.roomid,
      roomno: selectedRoom.roomno,
      customername: selectedRoom.custname,
      mobile: selectedRoom.mobile,
      orderId,
      billno: overall,
      amount: finalTotal,
      description: `Restaurant bill - Table ${selectedTable.seatname}`,
      createdAt: Timestamp.now(),
      userid: auth.currentUser?.uid

    });

    // 3️⃣ Reservation – PROPER recalculation
    const reservationRef = doc(db, "reservations", selectedRoom.reservationId);

    await runTransaction(db, async (tx) => {
      const snap = await tx.get(reservationRef);
      if (!snap.exists()) throw "Reservation not found";

      const data = snap.data();

      const oldResto = Number(data.restoamount || 0);
      const advance = Number(data.advance || 0);
      const oldtotal = Number(data.totalamount || 0);

      const newResto = oldResto + finalTotal;
      const newTotal = oldtotal + newResto;
      const newRemaining = newTotal - advance;

      tx.update(reservationRef, {
        restoamount: newResto,
        totalamount: newTotal,
        remaining: newRemaining,
      });
    });

    await addUserLog({
      action: "ROOM_POST",
      module: "ROOM",
      description: `Bill #${overall} posted to Room ${selectedRoom.roomno}`,
      orderid: orderId
    });


    Swal.fire("Success", "Bill posted to room", "success");

    setRoomPostOpen(false);
    setSelectedRoom(null);
    closePopup();
  };



  const maskMobile = (mobile = "") => {
    if (!mobile || mobile.length < 6) return "XX****";

    const first2 = mobile.slice(0, 2);
    const last4 = mobile.slice(-4);

    return `${first2}XXXX${last4}`;
  };


  const handleRoomChange = (e) => {
    const roomid = e.target.value;
    const room = roomOptions.find(r => r.roomid === roomid);
    setSelectedRoom(room || null);
  };

  const getTableDuration = (tableId) => {
    const order = runningOrders[String(tableId)];
    if (!order?.createdAt) return "";

    const start = order.createdAt.toDate();
    const now = new Date();
    const diff = Math.floor((now - start) / 1000);

    const hours = String(Math.floor(diff / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((diff % 3600) / 60)).padStart(2, "0");

    return `${hours}h ${minutes}m`;
  };


  const autoArrangeTables = async () => {
    if (!containerRef.current) return;

    const containerWidth = containerRef.current.offsetWidth;

    const tableWidth = 200;
    const tableHeight = 110;
    const gap = 10;

    let startY = 0;

    for (const cat of groupedTables) {

      let x = 0;
      let y = startY;

      for (const table of cat.tables) {

        if (x + tableWidth > containerWidth) {
          x = 0;
          y += tableHeight + gap;
        }

        await updateDoc(doc(db, "seatings", table.id), {
          posX: x,
          posY: y,
        });

        x += tableWidth + gap;
      }

      startY = y + tableHeight + 20;
    }

    Swal.fire("Done", "All tables adjusted properly", "success");
  };

  const containerRef = useRef(null);

  const getDynamicHeight = (tables) => {
    if (!tables.length) return 200;

    const tableHeight = 70; // your table card height
    const padding = 20;

    const maxY = Math.max(...tables.map(t => t.posY || 0));

    return maxY + tableHeight + padding;
  };


  const getLastCancelableBatch = (item) => {
    if (!item?.kotPrintHistory?.length) return null;

    const reversed = [...item.kotPrintHistory].reverse();

    return reversed.find(
      batch => batch.qty > (batch.cancelledQty || 0)
    );
  };

  const handleOpenCancel = (item) => {
    const lastBatch = getLastCancelableBatch(item);

    if (!lastBatch) {
      Swal.fire("Info", "Nothing to cancel", "info");
      return;
    }

    setCancelItem(item);
    setCancelQty(1);
    setCancelNote("");
    setCancelOpen(true);
  };

  const saveCancelKOT = async () => {
    if (!cancelItem) return;
    if (!cancelNote) {
      Swal.fire("Info", "Add note!", "warning");
      return;
    }

    const itemRef = doc(db, "orderitems", cancelItem.id);

    await runTransaction(db, async (transaction) => {
      const snap = await transaction.get(itemRef);
      if (!snap.exists()) throw "Item not found";

      const data = snap.data();

      const lastBatch = getLastCancelableBatch(data);
      if (!lastBatch) throw "Nothing to cancel";

      const maxCancelable =
        lastBatch.qty - (lastBatch.cancelledQty || 0);

      if (cancelQty > maxCancelable)
        throw `You can cancel only ${maxCancelable}`;

      const updatedHistory = data.kotPrintHistory.map(batch => {
        if (batch.printedAt.seconds === lastBatch.printedAt.seconds) {
          return {
            ...batch,
            cancelledQty: (batch.cancelledQty || 0) + cancelQty,
          };
        }
        return batch;
      });

      transaction.update(itemRef, {
        printedQty: data.printedQty - cancelQty,
        qty: data.qty - cancelQty,
        kotPrintHistory: updatedHistory,
      });
    });

    await addDoc(collection(db, "kotcancellogs"), {
      orderid: orderId,
      itemid: cancelItem.id,
      name: cancelItem.name,
      qty: cancelQty,
      note: cancelNote,
      createdAt: Timestamp.now(),
      userid: auth.currentUser?.uid,
      propertyId
    });

    await addUserLog({
      action: "CANCEL",
      module: "KOT",
      description: `Cancelled ${cancelQty} of ${cancelItem.name}. Reason: ${cancelNote}`,
      orderid: orderId,
      itemid: cancelItem.id
    });


    // ✅ Build Cancel KOT HTML
    const htmlContent = `
<html>
<body style="font-family: monospace; font-size:12px; width:260px; margin:0;">

 <div style="
  text-align:center;
  font-size:20px;
  font-weight:bold;
  background:#000;
  color:#fff;
  padding:6px;
">
  ❌ CANCEL ORDER ❌
</div>

  <div style="border-top:1px dashed #000; margin:6px 0;"></div>

  <div><b>Table:</b> ${selectedTable?.seatname || ""}</div>
  <div><b>Date:</b> ${moment().format("DD-MM-YYYY HH:mm")}</div>

  <div style="border-top:1px dashed #000; margin:6px 0;"></div>

  <div style="
      margin-bottom:8px; 
      padding:6px; 
      border:1px dashed red; 
      border-radius:6px;
  ">
    <div style="
        display:flex; 
        justify-content:space-between; 
        align-items:center;
    ">
      
      <div style="
          font-weight:bold; 
          font-size:13px; 
          max-width:130px; 
          word-wrap:break-word;
      ">
        ${cancelItem.name}
      </div>

      <div style="
          font-weight:bold;
          font-size:16px;
          border:1px solid red;
          padding:2px 8px;
          border-radius:4px;
          min-width:28px;
          text-align:center;
          color:red;
      ">
        -${cancelQty}
      </div>

    </div>

    <div style="
        margin-top:4px;
        font-size:10px;
        font-style:italic;
        border-top:1px dotted #000;
        padding-top:3px;
    ">
      📝 ${cancelNote}
    </div>

  </div>

  <div style="border-top:1px dashed #000; margin:6px 0;"></div>

  <div style="text-align:center; font-size:10px;">
    --- ITEM CANCELLED ---
  </div>

</body>
</html>
`;

    // ✅ Print Cancel KOT
    await window.electronAPI.silentPrint(htmlContent, kotPrinter);


    setCancelOpen(false);
    Toast.fire({ icon: "success", title: "KOT Cancelled" });
  };


  const addUserLog = async ({
    action,
    module,
    description,
    orderid = "",
    itemid = "",
    extra = {}
  }) => {
    try {
      await addDoc(collection(db, "restologs"), {
        propertyId,
        userid: auth.currentUser?.uid || "",
        useremail: auth.currentUser?.email || "",
        action,            // ADD / UPDATE / DELETE / PRINT / CANCEL
        module,            // ORDER / ITEM / BILL / ROOM
        description,       // readable message
        orderid,
        itemid,
        ...extra,
        createdAt: Timestamp.now(),
      });
    } catch (err) {
      console.log("Log Error:", err);
    }
  };


  const isKotPrinted = orderItems.some(
    item => (item.printedQty || 0) > 0
  );

  const isOrderEmpty = orderItems.filter(i => i.qty > 0).length === 0;


  useEffect(() => {
    setPaid(finalTotal);
  }, [finalTotal]);


  const handleChangeTable = async (newTable) => {
    setOpenTableModal(false)
    setSelectedTable(null);
    setOrderItems([]);
    setOrderId(null);

    if (!orderId || !selectedTable) return;

    const oldTable = selectedTable;

    // 🔥 Confirm Dialog With Note Input
    const result = await Swal.fire({
      title: "Change Table?",
      html: `
    <p>From <b>${oldTable.seatname}</b> → <b>${newTable.seatname}</b></p>
    <textarea id="tableNote" class="swal2-textarea" placeholder="Enter reason (optional)"></textarea>
  `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Change",
      cancelButtonText: "Cancel",
      backdrop: true,
      allowOutsideClick: false,
      customClass: {
        popup: "table-change-popup"
      },
      didOpen: () => {
        const popup = document.querySelector(".table-change-popup");
        if (popup) {
          popup.style.zIndex = "20000";
        }
      },
      preConfirm: () => {
        return document.getElementById("tableNote").value;
      },
    });
    if (!result.isConfirmed) return;

    const note = result.value || "";

    try {
      // ✅ Free old table
      await updateDoc(doc(db, "seatings", oldTable.id), {
        status: "FREE",
        updatedAt: Timestamp.now(),
      });

      // ✅ Occupy new table
      await updateDoc(doc(db, "seatings", newTable.id), {
        status: "OCCUPIED",
        updatedAt: Timestamp.now(),
      });

      // ✅ Update order table id + store note
      await updateDoc(doc(db, "orders", orderId), {
        tableid: newTable.id,
        tableChangeNote: note,
        tableChangedAt: Timestamp.now(),
        updatedAt: Timestamp.now(),
      });

      // ✅ Store separate log entry in Firestore
      await addDoc(collection(db, "tableChangeLogs"), {
        orderId,
        oldTableId: oldTable.id,
        newTableId: newTable.id,
        oldTableName: oldTable.seatname,
        newTableName: newTable.seatname,
        note,
        createdAt: Timestamp.now(),
        propertyId,
        userid: auth.currentUser?.uid,
      });

      // ✅ User Activity Log
      await addUserLog({
        action: "UPDATE",
        module: "TABLE",
        description: `Table changed from ${oldTable.seatname} to ${newTable.seatname}. Note: ${note}`,
        orderid: orderId,
      });

      setOpenTableModal(false);

      Toast.fire({
        icon: "success",
        title: "Table Changed Successfully ✅",
        timer: 1500,
        showConfirmButton: false,
      });

    } catch (error) {
      console.error("Table change error:", error);

      Swal.fire({
        icon: "error",
        title: "Something went wrong!",
      });
    }
  };

  /* ================= UI ================= */
  return (
    <Box className=" p-3">
      <Card>
        <CardContent>
          <Box display="flex" justifyContent="flex-end" mb={2}>
            <Button
              variant={dragEnabled ? "contained" : "outlined"}
              color={dragEnabled ? "success" : "secondary"}
              onClick={() => setDragEnabled(!dragEnabled)}
            >
              {dragEnabled ? "Drag Mode: ON" : "Drag Mode: OFF"}
            </Button>
            <Button
              variant="contained"
              color="primary"
              sx={{ ml: 2 }}
              onClick={autoArrangeTables}
            >
              Auto Arrange
            </Button>
          </Box>
          {groupedTables.map((cat) => (
            <Box key={cat.id} mb={4}>
              <Typography variant="h6" mb={1}>
                {cat.catname}
              </Typography>
              <Box ref={containerRef}

                sx={{
                  position: "relative",
                  width: "100%",
                  height: getDynamicHeight(cat.tables),
                  border: "1px solid #ccc",
                  borderRadius: 3,
                  mb: 4,
                  overflow: "hidden", p: 1
                }}
              >
                {cat.tables.map((t) => {
                  const active = Boolean(runningOrders[String(t.id)]);

                  return (
                    <Draggable disabled={!dragEnabled}
                      key={t.id}
                      defaultPosition={{
                        x: t.posX || 0,
                        y: t.posY || 0,
                      }}
                      onStop={async (e, data) => {
                        await updateDoc(doc(db, "seatings", t.id), {
                          posX: data.x,
                          posY: data.y,
                        });
                      }}
                    >
                      <Card
                        onClick={() => openTable(t)}
                        sx={{
                          position: "absolute",
                          width: 160,
                          height: 70,
                          cursor: "pointer",
                          borderRadius: "12px",
                          p: 1.5,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          background: active
                            ? "linear-gradient(135deg,#ff512f,#dd2476)"
                            : "linear-gradient(135deg,green,teal)",
                          color: "#fff",
                          boxShadow: active
                            ? "0 10px 25px rgba(59, 14, 34, 0.35)"
                            : "0 8px 20px rgba(0,0,0,0.15)",
                          transition: "all 0.3s ease",
                          "&:hover": {
                            transform: "translateY(-6px)",
                            boxShadow: "0 14px 30px rgba(0,0,0,0.25)",
                          },
                        }}
                      >
                        {/* Top Section */}
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                          <Typography fontWeight="bold" fontSize={17}>
                            {t.seatname}
                          </Typography>
                          {active ?
                            <Box
                              sx={{
                                fontSize: 10,
                                px: 1.2,
                                py: 0.4,
                                borderRadius: "20px",
                                background: "rgba(255,255,255,0.25)",
                                fontWeight: 600,
                              }}
                            >
                              <Typography>₹ {runningOrders[String(t.id)]?.liveTotal?.toFixed(0) || 0} </Typography>
                            </Box> : null}
                        </Box>

                        {/* Bottom Section */}
                        {active ? (
                          <>
                            <Box display="flex" justifyContent="space-between" mt={1}>
                              <Typography fontSize={11} sx={{ opacity: 0.9 }}>
                                🕒 {moment(
                                  runningOrders[String(t.id)]?.createdAt?.toDate()
                                ).format("HH:mm")}
                              </Typography>

                              <Typography fontSize={11} sx={{ opacity: 0.9 }}>
                                ⏱ {getTableDuration(t.id)}
                              </Typography>
                            </Box>


                          </>
                        ) : null}
                      </Card>
                    </Draggable>
                  );
                })}
              </Box>

            </Box>
          ))}

          {/* ================= ORDER POPUP ================= */}
          <Dialog open={Boolean(selectedTable)} fullScreen onClose={closePopup}>
            <Box sx={{ height: "100vh", bgcolor: colors.bg }}>

              <Box
                sx={{
                  px: 3,
                  py: 1,
                  bgcolor: colors.primary,
                  color: "#fff",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box>
                  <Typography fontWeight="bold" fontSize={18}>
                    🍽️ {selectedTable?.seatname}
                  </Typography>


                </Box>

                <Button
                  variant="contained"
                  onClick={() => setOpenTableModal(true)}
                >
                  Switch Table
                </Button>

                <Box>
                  <Typography fontSize={14} sx={{ opacity: 0.9 }}>
                    F1: KOT | F2: Bill | F3: Payment | F4: Room
                  </Typography>
                </Box>

                <IconButton
                  onClick={closePopup}
                  sx={{
                    backgroundColor: "#d32f2f",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#b71c1c" },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>

              {/* ================= BODY ================= */}
              <Grid className="row" spacing={2} p={2}>

                {/* ========== LEFT : CATEGORIES ========== */}
                <Grid className="col-sm-2" md={2}>
                  <Card sx={{ height: "100%", borderRadius: 3 }}>
                    <CardContent>
                      <Typography fontWeight="bold" mb={1}>
                        Categories
                      </Typography>

                      <Stack spacing={1}>
                        <Button
                          variant={!selectedProdCat ? "contained" : "outlined"}
                          onClick={() => setSelectedProdCat(null)}
                          sx={{
                            justifyContent: "flex-start",
                            borderRadius: 2,
                          }}
                        >
                          All
                        </Button>

                        {prodCats.map((cat) => (
                          <Button
                            key={cat.id}
                            onClick={() => handleCategoryClick(cat.id)}
                            variant={selectedProdCat === cat.id ? "contained" : "outlined"}
                            sx={{
                              justifyContent: "flex-start",
                              borderRadius: 2,
                            }}
                          >
                            {cat.catname}
                          </Button>
                        ))}

                      </Stack>
                    </CardContent>
                  </Card>
                </Grid>

                {/* ========== MIDDLE : PRODUCTS ========== */}
                <Grid className="col-sm-7" md={6}>
                  <Card sx={{ borderRadius: 3 }}>
                    <CardContent>

                      {/* Customer & Payment */}
                      <Stack direction="row" spacing={2} mb={2}>
                        <Autocomplete
                          size="small"
                          sx={{ width: "100%" }} options={customers}
                          getOptionLabel={(option) =>
                            option ? `${option.name} - ${option.mobile}` : ""
                          }
                          value={customers.find((c) => c.id === customerId) || null}
                          onChange={(event, newValue) => {
                            const selectedId = newValue ? newValue.id : "";
                            setCustomerId(selectedId);
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label="Customer" fullWidth />
                          )}
                        />

                        <Autocomplete
                          size="small"
                          sx={{ width: "100%" }} options={staffs}
                          getOptionLabel={(option) => (option ? option.name : "")}
                          value={staffs.find((s) => s.name === waiterId) || null}
                          onChange={(event, newValue) => {
                            const selectedName = newValue ? newValue.name : "";
                            setWaiterId(selectedName);
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label="Staff / Waiter" fullWidth />
                          )}
                        />
                        <TextField
                          fullWidth
                          size="small"
                          label="No of Persons"
                          value={noofpersons}
                          onChange={(e) => setnoofpersons(e.target.value)}
                        >

                        </TextField>

                      </Stack>

                      <Typography fontWeight="bold" mb={1}>
                        Menu Items
                      </Typography>

                      <Box sx={{
                        display: "flex",
                        gap: 2,
                        alignItems: "center",
                        width: "100%",
                      }}>
                        <Autocomplete
                          size="small" fullWidth
                          options={products}
                          value={selectedProduct}
                          inputValue={inputValue}
                          onInputChange={(event, newInputValue) => {
                            setInputValue(newInputValue);
                          }}
                          getOptionLabel={(option) =>
                            option?.prodname
                              ? `${option.prodname} - ₹${option.rate}`
                              : ""
                          }
                          onChange={async (event, newValue) => {
                            if (!newValue || !selectedTable) return;

                            await addItem(newValue);   // 🔥 your existing logic

                            // ✅ CLEAR BOTH
                            setSelectedProduct(null);
                            setInputValue("");
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Search & Select Menu"
                              placeholder="Type to search..."
                            />
                          )}
                        />

                        <TextField
                          type="text"
                          autoFocus size="small" fullWidth
                          placeholder="Scan or Enter Code"
                          value={barcodeInput}
                          onChange={(e) => setBarcodeInput(e.target.value)}
                          onKeyDown={async (e) => {
                            if (e.key === "Enter") {
                              const code = barcodeInput.trim();

                              const product = products.find(
                                (p) => String(p.codeno) === String(code)
                              );

                              if (product) {
                                await addItem(product);
                              } else {
                                Toast.fire({ icon: "error", title: "Invalid Code" });
                              }

                              setBarcodeInput("");
                            }
                          }}

                        />

                      </Box>


                      {/* Open Product */}
                      <Card
                        sx={{
                          mt: 2,
                          bgcolor: "#fff8e1",
                          borderRadius: 2,
                          border: "1px dashed #ffb300",
                        }}
                      >
                        <CardContent>
                          <Typography fontWeight="bold" mb={1}>
                            Open Product
                          </Typography>
                          <Stack direction="row" spacing={1}>
                            <TextField
                              size="small"
                              label="Name"
                              value={openProduct.name}
                              onChange={(e) => setOpenProduct({ ...openProduct, name: e.target.value })}
                            />

                            <TextField
                              size="small"
                              label="Qty"
                              type="number"
                              value={openProduct.qty}
                              onChange={(e) => setOpenProduct({ ...openProduct, qty: e.target.value })}
                            />

                            <TextField
                              size="small"
                              label="Rate"
                              type="number"
                              value={openProduct.rate}
                              onChange={(e) => setOpenProduct({ ...openProduct, rate: e.target.value })}
                            />

                            <Button variant="contained" color="warning" onClick={addOpenProduct}>
                              Add
                            </Button>

                          </Stack>
                        </CardContent>
                      </Card>

                      <Grid className="row mt-2" spacing={1}>
                        {filteredProducts.map((p) => (
                          <Grid className="col-sm-2 mt-2" key={p.id}>
                            <Card
                              onClick={() => addItem(p)}
                              sx={{
                                p: 1,
                                textAlign: "center",
                                cursor: "pointer",
                                borderRadius: 2,
                                bgcolor: colors.soft,
                                transition: "0.2s",
                                "&:hover": {
                                  bgcolor: colors.success,
                                  color: "#fff",
                                  transform: "scale(1.05)",
                                },
                              }}
                            >
                              <Box
                                display="flex"
                                alignItems="center"
                                gap={1}
                                fontWeight="bold"
                                fontSize={12}
                              >
                                {/* Veg / Non-Veg Indicator */}
                                <Box
                                  sx={{
                                    width: 12,
                                    height: 12,
                                    border: `2px solid ${p.type?.toLowerCase() === "veg" ? "#2e7d32" : "#d32f2f"}`,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    borderRadius: 1,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: 6,
                                      height: 6,
                                      borderRadius: "50%",
                                      bgcolor: p.type?.toLowerCase() === "veg" ? "#2e7d32" : "#d32f2f",
                                    }}
                                  />
                                </Box>

                                {p.prodname}
                              </Box>

                              {/* <Typography fontSize={13}>₹ {p.rate}</Typography> */}
                            </Card>
                          </Grid>
                        ))}
                      </Grid>

                    </CardContent>
                  </Card>
                </Grid>

                {/* ========== RIGHT : ORDER SUMMARY ========== */}
                <Grid className="col-sm-3" md={4}>
                  <Card sx={{ height: "100%", borderRadius: 3 }}>
                    <CardContent>
                      <Box
                        sx={{
                          height: 380,              // 🔒 fixed height (adjust if needed)
                          overflowY: "auto",        // 🖱️ vertical scroll
                          pr: 0.5,                  // space for scrollbar
                        }}
                      >
                        <Stack spacing={0.8}>
                          {orderItems
                            .filter(i => i.qty > 0)
                            .map((i) => (
                              <Box
                                key={i.id}
                                sx={{
                                  px: 1,
                                  py: 1,
                                  bgcolor: colors.soft,
                                  borderRadius: 1.5,
                                }}
                              >
                                {/* TOP ROW */}
                                <Box display="flex" alignItems="center">

                                  {/* Product Name */}
                                  <Box sx={{ width: "40%" }}>
                                    <Typography fontSize={13} fontWeight={600}>
                                      {i.name}
                                    </Typography>

                                    {/* Saved Note Display */}
                                    {i.note && activeNoteId !== i.id && (
                                      <Typography
                                        fontSize={11}
                                        color="warning.main"
                                        sx={{ fontStyle: "italic", mt: 0.5 }}
                                      >
                                        📝 {i.note}
                                      </Typography>
                                    )}
                                  </Box>

                                  {/* Qty Controls */}
                                  <Box
                                    sx={{
                                      width: "30%",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      gap: 0.5,
                                    }}
                                  >
                                    <IconButton size="small" onClick={() => decreaseQty(i)}>
                                      <RemoveIcon fontSize="small" />
                                    </IconButton>

                                    <Typography fontWeight={600}>
                                      {i.qty}
                                    </Typography>

                                    <IconButton size="small" onClick={() => increaseQty(i)}>
                                      <AddIcon fontSize="small" />
                                    </IconButton>
                                  </Box>

                                  {/* Total + Note Button */}
                                  <Box sx={{ width: "30%", textAlign: "right" }}>
                                    <Typography fontWeight={700}>
                                      ₹{(i.qty * i.rate).toFixed(2)}
                                    </Typography>

                                    <Button
                                      size="small"
                                      sx={{ mt: 0.5, fontSize: 10 }}
                                      onClick={() => {
                                        setActiveNoteId(i.id);
                                        setTempNote(i.note || "");
                                      }}
                                    >
                                      📝 Note
                                    </Button>

                                  </Box>
                                  {(i.printedQty || 0) > 0 && (
                                    <IconButton
                                      size="small"
                                      color="error"
                                      onClick={() => handleOpenCancel(i)}
                                    >
                                      <CancelIcon fontSize="small" />
                                    </IconButton>
                                  )}
                                </Box>

                                {/* NOTE INPUT (ONLY WHEN ACTIVE) */}
                                {activeNoteId === i.id && (
                                  <Box mt={1} display="flex" gap={1}>
                                    <TextField
                                      size="small"
                                      fullWidth
                                      placeholder="Enter note..."
                                      value={tempNote}
                                      onChange={(e) => setTempNote(e.target.value)}
                                    />

                                    <Button
                                      variant="contained"
                                      size="small"
                                      onClick={async () => {
                                        await updateNote(i, tempNote);
                                        setActiveNoteId(null);
                                        setTempNote("");
                                      }}
                                    >
                                      Save
                                    </Button>
                                  </Box>
                                )}
                              </Box>

                            ))}


                        </Stack>
                      </Box>

                      {/* ===== TOTAL BAR ===== */}
                      <Box
                        sx={{
                          mt: 1,
                          p: 1.5,
                          borderRadius: 2,
                          bgcolor: "#f5f7fa",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography fontSize={14} color="text.secondary">
                          Grand Total
                        </Typography>

                        <Typography
                          fontSize={22}
                          fontWeight="bold"
                          color="#2e7d32"
                        >
                          ₹{totalAmount.toFixed(2)}
                        </Typography>
                      </Box>




                      {/* ===== BOTTOM ACTION BAR ===== */}
                      <Stack
                        direction="row"
                        spacing={2}
                        justifyContent="center"
                        alignItems="center"
                        mt={2}
                      >

                        <Button
                          variant="contained"
                          color="info"
                          startIcon={
                            kotEnable ? (
                              <CheckIcon sx={{ color: "#fff" }} />
                            ) : (
                              <PrintIcon />
                            )
                          }
                          onClick={printKOT}

                        >
                          {kotEnable ? "KOT " : "KOT"}
                        </Button>

                        <Button
                          variant="contained"
                          color="warning"
                          startIcon={<PrintIcon />}
                          onClick={printBill}
                        // disabled={billAlreadyPrinted}
                        >
                          Bill
                        </Button>

                        <Button
                          variant="contained"
                          color="error"
                          startIcon={<CancelIcon />}
                          onClick={cancelOrder}
                          disabled={isKotPrinted && !isOrderEmpty}
                        >
                          Cancel
                        </Button>



                      </Stack>

                      {/* ===== PRIMARY ACTION ===== */}
                      <Button
                        fullWidth
                        variant="contained"
                        sx={{
                          mt: 1.5,
                          py: 1,
                          fontSize: 14,
                          fontWeight: "bold",
                          borderRadius: 2,
                          bgcolor: "#2e7d32",
                          "&:hover": { bgcolor: "#1b5e20" },
                        }}
                        onClick={() => {
                          setPaymentOpen(true);
                          setPaid(finalTotal);
                        }}
                      >
                        Proceed to Payment
                      </Button>

                      {
                        roomposting === "Yes" &&
                        <Button
                          fullWidth
                          variant="outlined"
                          onClick={() => setRoomPostOpen(true)}
                          sx={{ marginTop: 1 }}
                        >
                          Room Posting
                        </Button>
                      }


                    </CardContent>
                  </Card>
                </Grid>

              </Grid>

              {/* ================= FOOTER BUTTONS ================= */}


            </Box>
          </Dialog>

          <Dialog open={paymentOpen} maxWidth="xs" fullWidth>
            <DialogTitle>Payment</DialogTitle>

            <DialogContent>
              <Stack spacing={1.5} mt={1}>
                <TextField
                  size="small" label="Total"
                  value={totalAmount}
                  InputProps={{ readOnly: true }}
                />

                <Stack direction="row" spacing={1}>
                  <TextField
                    size="small"
                    type="number"
                    label="Discount"
                    fullWidth
                    value={discount}
                    onChange={(e) => setDiscount(Number(e.target.value))}
                  />

                  <TextField
                    select
                    size="small"
                    value={discountType}
                    onChange={(e) => setDiscountType(e.target.value)}
                    sx={{ width: 100 }}
                  >
                    <MenuItem value="amount">₹</MenuItem>
                    <MenuItem value="percent">%</MenuItem>
                  </TextField>
                </Stack>

                <TextField
                  size="small" label="Tip"
                  type="number"
                  value={tip}
                  onChange={(e) => setTip(Number(e.target.value))}
                />

                <FormControl fullWidth size="small">
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Payment Mode"
                    value={payMode} onChange={(e) => setPayMode(e.target.value)}
                  >
                    <MenuItem value="">Select Paymode</MenuItem>
                    {paymentModes.map((s) => (
                      <MenuItem key={s.id} value={s.id}>
                        {s.paymode}
                      </MenuItem>
                    ))}
                  </TextField>



                </FormControl>

                <TextField
                  label="Paid Amount"
                  type="number"
                  size="small"
                  value={paid}
                  disabled={!customerId}
                  onChange={(e) => {
                    const value = Number(e.target.value);

                    if (value > finalTotal) {
                      setPaid(finalTotal);
                    } else {
                      setPaid(value);
                    }
                  }}
                />

                <Button
                  size="small"
                  onClick={() => setPaid(finalTotal)}
                >
                  Pay Full Amount
                </Button>

                <Box
                  sx={{
                    bgcolor: "#f5f5f5",
                    p: 1,
                    borderRadius: 1,
                    textAlign: "center",
                  }}
                >
                  <Typography fontSize={13}>Final Total</Typography>
                  <Typography fontSize={18} fontWeight="bold">
                    ₹{finalTotal.toFixed(2)}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    bgcolor: "#f5f5f5",
                    p: 1,
                    borderRadius: 1,
                    textAlign: "center",
                  }}
                >
                  <Typography fontSize={13}>Remaining</Typography>
                  <Typography fontSize={18} fontWeight="bold" color={remaining <= 0 ? "green" : "red"}>
                    ₹{remaining.toFixed(2)}
                  </Typography>
                </Box>

                <FormControlLabel
                  control={
                    <Switch
                      checked={finalPrint}
                      onChange={(e) => setfinalPrint(e.target.checked)}
                    />
                  }
                  label="Print Bill"
                />


              </Stack>
            </DialogContent>

            <DialogActions>
              <Button onClick={() => setPaymentOpen(false)}>Back</Button>

              <Button
                variant="contained"
                color="success"
                onClick={finalSaveBill}
              >
                Confirm & Save
              </Button>
            </DialogActions>
          </Dialog>


          <Dialog open={roomPostOpen} maxWidth="sm" fullWidth>
            <DialogTitle>Room Posting</DialogTitle>

            <DialogContent>
              <Stack spacing={2} mt={1}>

                {/* ROOM SELECT */}
                <TextField
                  select
                  fullWidth
                  size="small"
                  label="Select Room"
                  value={selectedRoom?.roomid || ""}
                  onChange={handleRoomChange}
                >
                  <MenuItem value="">Select Room</MenuItem>

                  {roomOptions.map((r, i) => (
                    <MenuItem key={i} value={r.roomid}>
                      Room {r.roomno} — {r.roomtype}
                    </MenuItem>
                  ))}
                </TextField>


                {selectedRoom && (
                  <Card sx={{ bgcolor: "#f5f7fa", borderRadius: 2 }}>
                    <CardContent>
                      <Stack spacing={0.8}>
                        <Typography fontSize={13}>
                          <b>Customer:</b> {selectedRoom.custname}
                        </Typography>

                        <Typography fontSize={13}>
                          <b>Mobile:</b> {maskMobile(selectedRoom.mobile)}
                        </Typography>

                        <Typography fontSize={13}>
                          <b>Room No:</b> {selectedRoom.roomno} ({selectedRoom.roomtype})
                        </Typography>
                      </Stack>
                    </CardContent>
                  </Card>
                )}

                {/* AMOUNT */}
                <Box
                  sx={{
                    p: 1.5,
                    bgcolor: "#e8f5e9",
                    borderRadius: 2,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography>Total Amount</Typography>
                  <Typography fontWeight="bold">
                    ₹{finalTotal.toFixed(2)}
                  </Typography>
                </Box>

              </Stack>
            </DialogContent>

            <DialogActions>
              <Button onClick={() => setRoomPostOpen(false)}>Cancel</Button>

              <Button
                variant="contained"
                color="primary"
                disabled={!selectedRoom}
                onClick={postToRoom}
              >
                Post to Room
              </Button>
            </DialogActions>
          </Dialog>




          <Dialog open={cancelOpen} maxWidth="xs" fullWidth>
            <DialogTitle
              sx={{ bgcolor: "#d32f2f", color: "#fff", fontWeight: "bold" }}
            >
              Cancel KOT
            </DialogTitle>

            <DialogContent sx={{ bgcolor: "#ffebee" }}>
              {cancelItem && (
                <Stack spacing={2} mt={1}>
                  <Typography fontWeight="bold">
                    {cancelItem.name}
                  </Typography>

                  <Box display="flex" alignItems="center" justifyContent="center">
                    <IconButton
                      onClick={() => setCancelQty(q => Math.max(1, q - 1))}
                    >
                      <RemoveIcon />
                    </IconButton>

                    <Typography fontSize={20} fontWeight="bold">
                      {cancelQty}
                    </Typography>

                    <IconButton
                      onClick={() => {
                        const lastBatch = getLastCancelableBatch(cancelItem);
                        const max =
                          lastBatch.qty - (lastBatch.cancelledQty || 0);

                        if (cancelQty < max)
                          setCancelQty(q => q + 1);
                      }}
                    >
                      <AddIcon />
                    </IconButton>
                  </Box>

                  <TextField
                    size="small"
                    label="Cancel Reason"
                    value={cancelNote}
                    onChange={(e) => setCancelNote(e.target.value)}
                  />
                </Stack>
              )}
            </DialogContent>

            <DialogActions sx={{ bgcolor: "#ffcdd2" }}>
              <Button onClick={() => setCancelOpen(false)}>
                Close
              </Button>

              <Button
                variant="contained"
                color="error"
                onClick={saveCancelKOT}
              >
                Confirm Cancel
              </Button>
            </DialogActions>
          </Dialog>

          <Modal
            open={openTableModal}
            onClose={() => setOpenTableModal(false)}
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 500,
                bgcolor: "background.paper",
                p: 3,
                borderRadius: 2,
                boxShadow: 24,
                maxHeight: 500,
                overflowY: "auto",
              }}
            >
              <Typography variant="h6" mb={2}>
                Select Free Table
              </Typography>

              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(100px, 1fr))",
                  gap: 2,
                }}
              >
                {seatings
                  .filter((table) => {
                    const isFree = table.status === "FREE";
                    const hasRunningOrder = runningOrders[String(table.id)];
                    return isFree && !hasRunningOrder;
                  })
                  .slice()
                  .sort(
                    (a, b) =>
                      (a.createdAt?.seconds || 0) -
                      (b.createdAt?.seconds || 0)
                  )
                  .map((table) => (
                    <Button
                      key={table.id}
                      variant="contained"
                      color="success"
                      sx={{
                        height: 60,
                        borderRadius: 3,
                        fontWeight: "bold",
                      }}
                      onClick={() => handleChangeTable(table)}
                    >
                      {table.seatname}
                    </Button>
                  ))}
              </Box>
            </Box>
          </Modal>



        </CardContent>
      </Card>
    </Box>
  );
}
